import { LicenceApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const licenceApi = LicenceApi({}, '/api', axiosInstance);
